import { AccessControl } from "@careinfo/permission-required";
import APIS from "../../constant/EndPoint";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import TableActionButton from "../Reusable/TableActionButton";
import SwitchButton from "../Reusable/SwitchButton";
import SyncContact from "./SyncContact";
import Modal from "../Reusable/Modal";
import { useState } from "react";
import { tw } from "@careinfo/tailwind";
import Button from "../Reusable/Button";
import usePermission from "../../customHooks/usePermission";
import { useNavigate } from "react-router-dom";

const CustomerList = ({ handleSetIsActive }) => {
  const [openSyncContactPopUp, setOpenSyncContactPopup] = useState(false);
  const { isSuperUser } = usePermission();
  const navigate = useNavigate();
  const canEditCustomer = usePermission({
    allowedPermissions: ["can_update_customer"],
  });

  const handleRowClick = (row: any) => {
    if (!canEditCustomer) return;
    navigate(`edit/${row.original.id}`);
  };
  const defaultColumns: any = [
    {
      header: "Full Name",
      accessorKey: "full_name",
      cell: NACell,
    },
    {
      header: "Contact Number",
      accessorKey: "primary_contact",
      cell: NACell,
    },
    // {
    //   header: "Secondary Contact Number",
    //   accessorKey: "secondary_contact",
    //   cell: NACell,
    // },
    {
      header: "VAT/PAN",
      accessorKey: "vat_pan",
      cell: NACell,
    },
    {
      header: "Email",
      accessorKey: "email",
      cell: NACell,
    },

    {
      header: "Address",
      accessorKey: "address",
      cell: NACell,
    },
    {
      header: "Active",
      accessorKey: "is_active",
      cell: ({ row, getValue }: any) => (
        <div onClick={(e) => e.stopPropagation()}>
          <SwitchButton
            id={row?.original?.id}
            value={getValue()}
            disabled={false}
            onChange={handleSetIsActive}
          />
        </div>
      ),
    },
    // {
    //   header: "Action",
    //   accessorKey: "id",
    //   cell: ({ row, getValue }: any) => (
    //     <>
    //       <AccessControl
    //         children={<TableActionButton editPath={`edit/${getValue()}`} />}
    //         allowedPermissions={["can_update_user"]}
    //       />
    //     </>
    //   ),
    // },
  ];

  return (
    <>
      <AccessControl
        allowedPermissions={["can_view_customer"]}
        children={
          <DataTable
            url={APIS.CUSTOMER}
            queryKey={"customer"}
            columns={defaultColumns}
            addNewPagePath={"/create"}
            tableName={"customer-list"}
            actionMenu={
              <>
                <div className={tw`flex items-center justify-end w-full `}>
                  <div className={tw`w-24`}>
                    <Button
                      label={"Sync Contact"}
                      type="button"
                      onClick={() => setOpenSyncContactPopup(true)}
                    />
                  </div>
                </div>
              </>
            }
            onRowClick={handleRowClick}
          />
        }
      />
      <Modal
        title={"Sync Contact"}
        isOpen={openSyncContactPopUp}
        setIsOpen={setOpenSyncContactPopup}
      >
        <SyncContact setOpenSyncContactPopup={setOpenSyncContactPopup} />
      </Modal>
    </>
  );
};

export default CustomerList;
